module.exports = __webpack_public_path__ + "img/alex-tampi-dashboard.6dd9832d.png";